<div class="main-container">
  <div class="comisiones-content">
    <span style="font-size: larger; font-weight: bold">
      Consulta Mis Comisiones
    </span>

    <form [formGroup]="frmComisiones" autocomplete="off">
      <div class="form-container row d-flex align-items-center flex-wrap">
        <!-- Año -->
        <div class="col-12 col-lg-3 d-flex align-items-center mt-3 mt-lg-0">
          <label class="me-2 label-alineada" style="white-space: nowrap"
            >Seleccione el año a consultar:</label
          >

          <mat-form-field
            appearance="fill"
            class="campo-igual"
            hideRequiredMarker
          >
            <mat-label>Año</mat-label>
            <mat-select formControlName="documentAño" required>
              <mat-option *ngFor="let anio of listaAnios" [value]="anio">
                {{ anio }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Periodo CORREGIDO -->
        <div
          class="periodo col-12 col-lg-3 d-flex align-items-center mt-3 mt-lg-0"
          style="margin-left: 5vh"
        >
          <label class="me-2 label-alineada" style="white-space: nowrap"
            >Seleccione el período a consultar:</label
          >

          <mat-form-field
            appearance="fill"
            class="campo-igual"
            hideRequiredMarker
          >
            <mat-label>Periodo</mat-label>
            <mat-select formControlName="documentPeriodo">
              <!-- ❌ REMOVIDO: [disabled] -->
              <mat-option *ngFor="let periodo of listaPeriod" [value]="periodo">
                {{ periodo }}
              </mat-option>
            </mat-select>

            <mat-error
              *ngIf="
                getControl['documentAño'].touched &&
                getControl['documentAño'].invalid
              "
            >
              Debe seleccionar un año.
            </mat-error>
          </mat-form-field>

          <div class="btnComisiones col-12 col-lg-6 mt-3 mt-lg-0">
            <button
              class="btn btn-primary btn-icon"
              type="button"
              (click)="generarComprobanteComisiones()"
              appTrackClick
              [trackData]="trackDataCarnet"
            >
              <mat-icon>download</mat-icon>
              <span
                >GENERAR <br />
                COMPROBANTE <br />
                COMISIONES</span
              >
            </button>
          </div>
        </div>

        <!-- Mensaje general -->
        <span *ngIf="generalMessage" class="message-container message-span">
          {{ generalMessage.toUpperCase() }}
        </span>
      </div>
    </form>
    <!-- Comprobantes desde OVA -->
    <div *ngIf="comprobantesOva.length > 0" class="mt-4">
      <h3>Comprobantes desde OVA</h3>
      <table class="table table-bordered table-striped">
        <thead>
          <tr>
            <th *ngFor="let key of getKeys(comprobantesOva[0])">{{ key }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of comprobantesOva">
            <td *ngFor="let key of getKeys(item)">{{ item[key] }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Detallado desde OVA -->
    <div *ngIf="detalladoOva.length > 0" class="mt-4">
      <h3>Detallado desde OVA</h3>
      <table class="table table-bordered table-striped">
        <thead>
          <tr>
            <th *ngFor="let key of getKeys(detalladoOva[0])">{{ key }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of detalladoOva">
            <td *ngFor="let key of getKeys(item)">{{ item[key] }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
